// This module configures the URLs used to store and access data on the server
// ===============================================================================
const baseUrl = 'https://stockwatch.bustbyte.no';
export const apiUrl  = `${baseUrl}/api`;
export const authUrl = `${baseUrl}/auth`;
